module.exports = __webpack_public_path__ + "static/media/boots4x.570ccd16.png";